import { ProjectEstimateAtCompletionBase } from './base/project-estimate-at-completion-base';

export class ProjectEstimateAtCompletion extends ProjectEstimateAtCompletionBase { }